export default __webpack_public_path__ + "static/media/strategik5.688a51b2.jpg";